<template>
  <div id="myInfoForm">
    <common-member-form :from="'myInfoForm'"/>
  </div>
</template>

<script>
import CommonMemberForm from '../common/CommonMemberForm.vue'

export default {
  components: { CommonMemberForm },
  mounted () {
    this.$emit('setMenu', '')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/MyInfoForm.vue